{
    "name": "Vivedino",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Vivedino configurations",
    "machine_model_list": [
        {
            "name": "Troodon 2.0 - RRF",
            "sub_path": "machine/Troodon2RRF.json"
        },
        {
            "name": "Troodon 2.0 - Klipper",
            "sub_path": "machine/Troodon2Klipper.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "fdm_process_klipper_common",
            "sub_path": "process/fdm_process_klipper_common.json"
        },
        {
            "name": "0.08mm Extra Fine @Troodon2",
            "sub_path": "process/0.08mm Extra Fine @Troodon2.json"
        },
        {
            "name": "0.12mm Fine @Troodon2",
            "sub_path": "process/0.12mm Fine @Troodon2.json"
        },
        {
            "name": "0.15mm Optimal @Troodon2",
            "sub_path": "process/0.15mm Optimal @Troodon2.json"
        },
        {
            "name": "0.20mm Standard @Troodon2",
            "sub_path": "process/0.20mm Standard @Troodon2.json"
        },
        {
            "name": "0.24mm Draft @Troodon2",
            "sub_path": "process/0.24mm Draft @Troodon2.json"
        },
        {
            "name": "0.28mm Extra Draft @Troodon2",
            "sub_path": "process/0.28mm Extra Draft @Troodon2.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_pc",
            "sub_path": "filament/fdm_filament_pc.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "fdm_filament_pva",
            "sub_path": "filament/fdm_filament_pva.json"
        },
        {
            "name": "fdm_filament_pa",
            "sub_path": "filament/fdm_filament_pa.json"
        },
        {
            "name": "Generic PLA @Troodon",
            "sub_path": "filament/Generic PLA @Troodon.json"
        },
        {
            "name": "Generic PLA-CF @Troodon",
            "sub_path": "filament/Generic PLA-CF @Troodon.json"
        },
        {
            "name": "Generic TPU @Troodon",
            "sub_path": "filament/Generic TPU @Troodon.json"
        },
        {
            "name": "Generic PETG @Troodon",
            "sub_path": "filament/Generic PETG @Troodon.json"
        },
        {
            "name": "Generic ABS @Troodon",
            "sub_path": "filament/Generic ABS @Troodon.json"
        },
        {
            "name": "Generic PC @Troodon",
            "sub_path": "filament/Generic PC @Troodon.json"
        },
        {
            "name": "Generic ASA @Troodon",
            "sub_path": "filament/Generic ASA @Troodon.json"
        },
        {
            "name": "Generic PVA @Troodon",
            "sub_path": "filament/Generic PVA @Troodon.json"
        },
        {
            "name": "Generic PA @Troodon",
            "sub_path": "filament/Generic PA @Troodon.json"
        },
        {
            "name": "Generic PA-CF @Troodon",
            "sub_path": "filament/Generic PA-CF @Troodon.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "fdm_klipper_common",
            "sub_path": "machine/fdm_klipper_common.json"
        },
        {
            "name": "fdm_rrf_common",
            "sub_path": "machine/fdm_rrf_common.json"
        },
        {
            "name": "Troodon 2.0 Klipper 0.4 nozzle",
            "sub_path": "machine/Troodon 2.0 Klipper 0.4 nozzle.json"
        },
        {
            "name": "Troodon 2.0 RRF 0.4 nozzle",
            "sub_path": "machine/Troodon 2.0 RRF 0.4 nozzle.json"
        }
    ]
}